import { UseCaseTemplate } from "@/components/institutional/UseCaseTemplate";

const Retention = () => (
  <UseCaseTemplate
    seoTitle="Retention Support — Use Case"
    seoDescription="CSW helps institutions identify students who may benefit from earlier outreach. Behavioral signals support — never replace — retention teams' judgment and human-in-the-loop decisions."
    canonicalUrl="/use-cases/retention/"
    eyebrow="Use case · Retention support"
    h1={<>Add a behavioral layer to your retention work.</>}
    intro={<>Retention initiatives are most effective when teams can reach out before disengagement compounds.
      CSW provides visibility into engagement patterns so retention staff can identify students who may
      benefit from support — without claiming to predict who will or won't persist.</>}
    challenge={<>
      Retention work is almost always reactive. By the time a student is formally flagged at-risk,
      multiple behavioral indicators have usually been present. Teams want to operate earlier, but
      they need behavioral context that's defensible, explainable, and respects the limits of what
      data can actually tell us.
    </>}
    approach={[
      { title: "Cohort-level engagement visibility", description: "See how engagement is trending across programs, terms, and populations — not just at the individual level." },
      { title: "Per-student risk indicators with evidence", description: "Identify students potentially at elevated risk based on behavioral pattern shifts, with explainable evidence cards." },
      { title: "Outcomes loop for retention teams", description: "Log outreach decisions and outcomes to learn what supports actually help — with full auditability." },
    ]}
    outcome={<>
      A retention coordinator can see a cohort-level engagement view alongside per-student risk
      indicators. They prioritize outreach using behavioral evidence in addition to academic data,
      and capture the outcomes of their outreach back into the system. Over time, the team learns
      which kinds of support tend to land — but the decisions stay with the team.
    </>}
    trustNote="CSW supports retention initiatives. It does not guarantee retention outcomes, prevent dropout, or identify students who will fail — its role is to surface behavioral signals for human review."
    relatedAudiences={[
      { href: "/for/universities/", label: "CSW for Universities" },
      { href: "/for/colleges/", label: "CSW for Colleges" },
      { href: "/for/online-programs/", label: "CSW for Online Programs" },
    ]}
    relatedPlatform={{ href: "/platform/risk-indicators/", label: "Platform: Risk indicators" }}
    relatedUseCases={[
      { href: "/use-cases/early-warning/", title: "Early-warning signals" },
      { href: "/use-cases/at-risk-cohorts/", title: "At-risk cohorts" },
      { href: "/use-cases/first-year-experience/", title: "First-year experience" },
    ]}
  />
);
export default Retention;
